<template>
  <UiModalContainer
    v-if="showModal"
    footer-classes="flex justify-end gap-3"
    :modal-show="showModal"
    :modal-width="50"
    @handleClick="handleClick"
  >
    <template v-slot:header>
      <span class="sm:text-2.5xl text-lg font-medium">Request For Demo</span>
    </template>
    <template v-slot>
      <div class="showModal-body p-5 sm:p-7.5">
        <div class="flex sm:gap-7.5 flex-wrap">
          <UiInputBox
            v-model="requestDemo.first_name"
            title="First Name"
            name="First Name"
            :hide-title="true"
            class="w-full min-w-1 sm:w-1/2"
            placeholder="First Name"
            rules="alpha"
            :error-message="errors['first_name']"
            :check-is-data-valid="startValidation"
            @emitError="setError($event, 'first_name')"
          />

          <UiInputBox
            v-model="requestDemo.last_name"
            title="Last Name"
            name="Last Name"
            :hide-title="true"
            class="flex-1 min-w-1"
            rules="alpha"
            placeholder="Last Name"
            :error-message="errors['last_name']"
            :check-is-data-valid="startValidation"
            @emitError="setError($event, 'last_name')"
          />
        </div>
        <div class="flex sm:gap-7.5 flex-wrap">
          <UiInputBox
            v-model="requestDemo.institute_name"
            title="Institute Name"
            name="FNAME"
            :hide-title="true"
            rules="alpha_spaces"
            :error-message="errors['institute_name']"
            :check-is-data-valid="startValidation"
            class="flex-1 min-w-1"
            placeholder="Institute Name"
            @emitError="setError($event, 'institute_name')"
          />
        </div>
        <div class="flex sm:gap-7.5 flex-wrap">
          <UiInputBox
            v-model="requestDemo.requester_role"
            title="Your Role"
            :hide-title="true"
            class="w-full min-w-1 sm:w-1/2"
            placeholder="YOUR_ROLE"
          />
          <UiInputBox
            v-model="requestDemo.email"
            title="Email"
            name="Email"
            :hide-title="true"
            class="flex-1 min-w-1"
            placeholder="Email"
            rules="required|email"
            :error-message="errors['email']"
            :check-is-data-valid="startValidation"
            @emitError="setError($event, 'email')"
          />
        </div>

        <div class="flex gap-7.5 flex-wrap">
          <Country v-model="countryDetails" class="w-full sm:w-1/2" />
          <Phone v-model="phoneNumber" class="flex-1" />
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="flex gap-5 mr-3">
        <button
          v-i18n="salary"
          class="border rounded-lg text-text-primary-light-grey text-sm sm:text-lg py-2 px-3 md:px-7 w-24 h-12 sm:w-36 sm:h-14"
          @click="closeModal"
        >
          Cancel
        </button>
        <button
          class="bg-primary-purple-600 rounded-lg text-primary-purple-600 font-medium py-2 px-3 md:px-7 lg:text-lg leading-34 text-base tracking-normal flex items-center gap-3 z-[1] w-24 h-12 sm:w-36 sm:h-14 justify-center"
          :disabled="isLoading"
          @click="sumbitForm"
        >
          <span v-if="isLoading">
            <Loader class="mx-auto" />
          </span>
          <h5 v-else class="text-white">Submit</h5>
        </button>
      </div>
    </template>
  </UiModalContainer>
</template>

<script>
import UiInputBox from '@src/views/SignUpPage/UiInputBox.vue'
import UiModalContainer from '@src/components/UiElements/UiModalContainer.vue'
import countries from '@src/constants/countriesArray'
import { BASE_API_URL, ADMIN_API_URL } from '@services/.env'
import Loader from '@src/views/SignUpPage/Loader.vue'
import Country from '@src/components/misc/Countries.vue'
import Phone from '@src/views/SignUpPage/PhoneNumber.vue'

export default {
  name: 'RequestDemoModal',
  components: {
    UiModalContainer,
    UiInputBox,
    Loader,
    Country,
    Phone,
  },
  props: {
    showDemoModal: { type: Boolean, default: false },
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      countryDetails: '',
      selectedCountry: '',
      startValidation: false,
      selectedCountryCode: '92',
      phoneNumber: '',
      countryList: [],
      requestDemo: {
        first_name: '',
        last_name: '',
        institute_name: '',
        requester_role: '',
        email: '',
        phone: '',
        country: '',
      },
      errors: {
        first_name: '',
        last_name: '',
        institute_name: '',
        requester_role: '',
        email: '',
        phone: '',
      },
    }
  },

  watch: {
    showDemoModal: {
      immediate: true,
      handler(value) {
        this.showModal = value
      },
    },
    selectedCountry: {
      handler(value) {
        this.selectedCountryCode = this.countryList[value].countryCode
      },
    },
    phoneNumber: {
      handler(value) {
        this.requestDemo.phone = value.number
      },
    },
    countryDetails: {
      immediate: true,
      handler(value) {
        this.requestDemo.country = value.name
      },
    },
  },
  created() {
    for (let i = 0; i < countries.length; i++) {
      let country = countries[i]
      if (country[2] === '44') this.selectedCountry = i
      this.countryList.push({
        displayName: `${country[0]} ${country[2]}`,
        id: i,
        name: country[0],
        alpha2Code: country[1],
        countryCode: `${country[2]}`,
      })
    }
    this.requestDemo.country = 'pakistan'
  },
  methods: {
    setError(error, key) {
      this.errors[key] = error
    },
    closeModal() {
      this.showModal = !this.showModal
      this.$emit('closeShowModal')
    },
    sumbitForm() {
      this.startValidation = true
      let isValid
      setTimeout(() => {
        Object.entries(this.errors).forEach(([key, value]) => {
          if (value !== '') isValid = true
        })
        if (isValid) return
        this.doRequestDemo()
      }, 0)
    },
    doRequestDemo() {
      this.isLoading = true

      fetch(`${BASE_API_URL}${ADMIN_API_URL}demo_requests`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.requestDemo),
      })
        .then((response) => {
          if (response.ok) return response.json()

          throw new Error('Something went wrong')
        })
        .then((response) => {
          this.$store.commit('NEW', {
            type: 'success',
            message: this.$t(`toast.DEMO_REQUESTED_ACCEPTED`),
          })

          this.closeModal()
          this.$emit('receivedDemo')
        })
        .catch((error) => {
          this.$store.commit('NEW', {
            type: 'error',
            message: 'Error occurred in form filling',
          })
        })
        .finally(() => (this.isLoading = false))
    },
    handleClick(value) {
      if (value === 'close') return this.$emit('closeShowModal')
    },
  },
}
</script>

<style lang="scss" module>
.widthItems {
  min-width: 30%;
}
</style>

<style scoped>
.btn-green {
  background: transparent linear-gradient(253deg, #0f9f5d 0%, #09814a 100%) 0% 0% no-repeat
    padding-box;
}
</style>